import React from 'react';

import type { SwitchToggleChangeEventHandler } from 'js/src/components/common/ui/SwitchToggle';
import SwitchToggle from 'js/src/components/common/ui/SwitchToggle';
import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';

type Props = {
    title: string;
    description?: string | React.ReactNode;
    checked?: boolean;
    onChange: SwitchToggleChangeEventHandler;
    isDisabled?: boolean;
    tooltipMessage?: string;
};

const SettingsToggle: React.FC<Props> = React.memo(function SettingsToggle({
    title,
    description,
    checked,
    onChange,
    isDisabled = false,
    tooltipMessage = '',
}) {
    return (
        <div className="row">
            <div className="col-sm-10">
                <div className="row">
                    <div className="col-lg-4">
                        <label>{title}</label>
                    </div>
                    <div className="col-lg-8">{description}</div>
                </div>
            </div>
            <Tooltip
                title={tooltipMessage}
                trigger="hover"
                placement={Placement.TOP}
                show={!!tooltipMessage}
            >
                <div className="col-sm-2">
                    <SwitchToggle checked={checked} disabled={isDisabled} onChange={onChange} />
                </div>
            </Tooltip>
        </div>
    );
});

export default SettingsToggle;
